// extracted by mini-css-extract-plugin
export default {"section":"Ss-z","sectionTitle":"Ts-z","fieldWrapper":"Us-z","formField":"Vs-z","disabled":"Ws-z","formLabel":"Xs-z"};